function init() {
    const body = document.querySelector("body");
    const buttonOpen = document.querySelector(".js-menu-open");
    const buttonClose = document.querySelector(".js-menu-close");
    const drawer = document.querySelector(".o-drawer");
    const dropDown = document.querySelectorAll("ul.mobile-primary-menu__list > .menu-item-has-children");
    const ignoreTheseElements = document.querySelectorAll(".site > .header, .site > .content, .site > footer");
    let prevWidth = window.innerWidth;

    // === Drawer and Menu === // 

    // open main nav drawer
    const openNav = () => {
        drawer.scroll(0, 0);
        body.classList.add("show-menu", "visible");
        drawer.setAttribute('aria-hidden', 'false');
        buttonClose.focus();
        
        setInert();
    };

    // close main nav drawer
    const closeNav = (wasMouseClick) => {
        body.classList.remove("show-menu");
        drawer.setAttribute('aria-hidden', 'true');
    
        setTimeout(() => {
            body.classList.remove("visible");
            dropDown.forEach((subnav) => {
                subnav.classList.remove("expanded", "visible");
                subnav.setAttribute('aria-expanded', 'false');
                drawer.scroll(0, 0);
            });
        }, 250);
        removeInert();
        
        if(!wasMouseClick){
            buttonOpen.focus();
        }
    };

    // === Focus setting === // 

    // disable focus for non-mobile menu items
    const setInert = () => {
        ignoreTheseElements.forEach(element => {
            element.setAttribute("inert", "true");
        })
    }

    // re-enable focus for non-mobile menu items
    const removeInert = () => {
        ignoreTheseElements.forEach(element => {
            element.removeAttribute("inert");
        })
    }

    // === Submenus === // 

    // open dropdown subnav in drawer
    const openSubMenu = (menuItem) => {
        menuItem.classList.add("expanded", "visible");
        menuItem.setAttribute('aria-expanded', 'true');
    };

    // close dropdown subnav in drawer
    const closeSubMenu = (menuItem) => {
        menuItem.classList.remove("expanded");
        menuItem.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            menuItem.classList.remove("visible");

        }, 250);
    };
    
    // === Listeners === // 

    buttonOpen.addEventListener('click', () => {
        openNav();
    });

    buttonClose.addEventListener('click', () => {
        closeNav(true);
    });

    window.addEventListener("resize", () => {
        if (window.innerWidth !== prevWidth ) {
            prevWidth = window.innerWidth;
            closeNav();
        }
    });

    window.addEventListener('keydown', (event) => {
        if(!body.classList.contains("show-menu")){
            return
        }
        let keyName = event.code;
        if (keyName === 'Escape') {
            closeNav();
        }
    })

    // handles submenus
    dropDown.forEach((subMenu) => {
        
        subMenu.addEventListener("click", (event) => {
            if (event.target.classList.contains("expanded")) {
                closeSubMenu(event.target);
            } else {
                openSubMenu(event.target);
            }
        });

        // Enter key listener
        subMenu.addEventListener('keydown', (event) => {
            let keyName = event.code;
            if (keyName === 'Enter') {
                if (event.target.parentNode.classList.contains("expanded")) {
                    closeSubMenu(event.target.parentNode);
                } else {
                    openSubMenu(event.target.parentNode);
                }
            }
        });
    });
}

export { init as default };
